import { render } from "./ColaboradorIndex.vue?vue&type=template&id=8f95a584&ts=true"
import script from "./ColaboradorIndex.vue?vue&type=script&lang=ts"
export * from "./ColaboradorIndex.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__